// getPhamula 获取方程式数据


/*
    补齐以下字段
    edd、rt、su
    ed、tg
    _object_data、_tuwen_data、_phamula_data
    _name、_photo、_audio、_audio_duration、_video、_video_duration
*/


/*
    引入http请求，必须包含以下几个请求方法
    object.detail、object.detail_list
    tuwen.detail
    phamula.detail
    user.public_profile
*/
import * as http from '@/http/index.js'

/**** 图片、音频、视频数据存储到本地 ****/
const storageKey = 'XITO_FILE';
const storageType = 'localStorage';

/**** 缓存用户、图文、对象、方程式数据 ****/
const userData = Object.create(null);
const tuwenData = Object.create(null);
const objectData = Object.create(null);
const phamulaData = Object.create(null);

/**** http请求 ****/
async function getUser(user_id = '', fromLocal = true) {
    if (userData[user_id] && fromLocal) {
        return {
            status: 'success',
            data: userData[user_id]
        };
    }
    let result = await http.user.public_profile(user_id);
    if (result.status === 'success') {
        userData[user_id] = Object.assign(userData[user_id] || {}, result.data);
    }
    return result;
}
async function getTuwen(tuwen_id = '', fromLocal = true) {
    if (tuwenData[tuwen_id] && fromLocal) {
        return {
            status: 'success',
            data: tuwenData[tuwen_id]
        };
    }
    let result = await http.tuwen.detail(tuwen_id);
    if (result.status === 'success') {
        tuwenData[tuwen_id] = Object.assign(tuwenData[tuwen_id] || {}, result.data);
    }
    return result;
}
async function getObject(object_id = '', fromLocal = true) {
    if (objectData[object_id] && fromLocal) {
        return {
            status: 'success',
            data: objectData[object_id]
        };
    }
    let data = null;
    let status = 'error';
    let result_1 = await http.object.detail(object_id);
    let result_2 = await http.object.detail_list(object_id);
    if (result_1.status === 'success') {
        data = result_1.data;
        status = 'success';
    }
    if (result_2.status === 'success') {
        if (result_2.data.length) {
            data = data ? Object.assign(data, result_2.data[0]) : result_2.data[0];
            status = 'success';
        }
    }
    if (status === 'success') {
        objectData[object_id] = Object.assign(objectData[object_id] || {}, data);
    }
    return {
        status,
        data
    };
}
async function getPhamula(phamula_id = '', fromLocal = true) {
    if (phamulaData[phamula_id] && fromLocal) {
        return {
            status: 'success',
            data: phamulaData[phamula_id]
        };
    }
    let result = await http.phamula.detail(phamula_id);
    if (result.status === 'success') {
        phamulaData[phamula_id] = Object.assign(phamulaData[phamula_id] || {}, result.data);
    }
    return result;
}

/**** 获取、设置本地文件数据 ****/
function getLocalFile() {
    if (storageKey && storageType && window[storageType]) {
        return JSON.parse(window[storageType].getItem(storageKey) || '[]');
    }
    return [];
}
function setLocalFile(file = {}) {
    if (storageKey && storageType && window[storageType]) {
        const fileList = getLocalFile();
        const index = fileList.findIndex(_file => _file['url'] == file['url']);
        if (index === -1) {
            const newFile = JSON.parse(JSON.stringify(file));
            delete newFile['status']; // 删除这个可能存在的字段
            fileList.unshift(newFile);
            window[storageType].setItem(storageKey, JSON.stringify(fileList));
        }
    }
}

/**** 辅助函数 ****/
// 数据类型
function dataType(data = null, type = '') {
    let _type = Object.prototype.toString.apply(data).slice(8, -1).toLowerCase();
    return type ? (type.indexOf(_type) > -1) : _type;
}
// 是否大于零
function thanZero(number = '') {
    if (['string', 'number'].indexOf(typeof number) > -1) {
        if (number !== '' && isNaN(number) === false) {
            if (Number(number) > 0) {
                return true;
            }
        }
    }
    return false;
}
// 文件类型
function fileType(url = '', _type = '') {
    // url文件链接，type如果传了就判断相不相等，否则返回文件类型
    let __type = '';
    let suffix = '';
    try {
    	let temp = url.split('.');
    	suffix = temp[temp.length - 1];
    } catch (err) {
    	suffix = '';
    }
    const typeConfig = {
    	'txt': [ 'txt' ],
    	'pdf': [ 'pdf' ],
    	'ppt': [ 'ppt', 'pptx' ],
    	'word': [ 'doc', 'docx' ],
    	'excel': [ 'xls', 'xlsx' ],
    	'image': [ 'png', 'jpg', 'jpeg', 'bmp', 'gif' ],
    	'audio': [ 'wav', 'mp3', 'm4a', 'ogg', 'acc', 'webm' ],
    	'video': [
    			'avi', 'flv', 'mpg', 'mpeg', 'mpe', 'm1v', 'm2v',
    			'mpv2', 'mp2v', 'dat', 'ts', 'tp', 'tpr', 'pva',
    			'pss', 'mp4', 'm4v', 'm4p', 'm4b', '3gp', '3gpp',
    			'3g2', '3gp2', 'mov', 'qt', 'amr', 'rm',
    			'ram', 'rmvb', 'rpm', 'mkv', 'wmv'
    		],
    };
    for (let [type, list] of Object.entries(typeConfig)) {
    	let result = list.find(v => v === suffix);
    	if (result) {
    		__type = type;
    		break;
    	}
    }
    if (_type) {
    	return __type === _type;
    }
    return __type || suffix;
}
// 树结构遍历(非异步函数)
function treeEach(tree = {}, callback = null, key = 'su') {
    if (dataType(tree, 'object') && dataType(callback, 'function') && key) {
        let result = callback(tree);
        tree = result === undefined ? tree : result;
    	if (tree && tree[key] && dataType(tree[key], 'array')) {
    		for (let i = 0, length = tree[key].length; i < length; i++) {
    			tree[key][i] = treeEach(tree[key][i], callback, key);
    		}
    	}
    }
    return tree;
}
// 文件信息(异步函数)
export function fileInfo(src = '', type = '') {
    return new Promise(resolve => {
        const data = Object.create(null);
        data['status'] = 'error';
        data['type'] = type;
        data['url'] = src;
        let element = null;
        // 如果是图片
        if (type === 'image') {
            element = new Image();
            element.addEventListener('load', function() {
                data['height'] = Math.round(this.height * 100) / 100;
                data['width'] = Math.round(this.width * 100) / 100;
                data['status'] = 'success';
                element = null;
                resolve(data);
            });
            element.addEventListener('error', function() {
            	data['height'] = 0;
            	data['width'] = 0;
            	element = null;
            	resolve(data);
            });
            element.src = src;
            // element.load(); // 图片对象没有load事件
        }
        // 如果是音频
        else if (data['type'] === 'audio') {
            element = new Audio();
            element.addEventListener('loadedmetadata', function() {
            	// 安卓手机端的时长为0，使用定时器延迟获取仍然为0，且链接错误时不会触发error事件
            	data['duration'] = Math.round(element.duration * 100) / 100;
            	data['status'] = 'success';
            	element = null;
            	resolve(data);
            });
            element.addEventListener('error', function() {
            	data['duration'] = 0;
            	element = null;
            	resolve(data);
            });
            element.src = src;
            element.load();
        }
        // 如果是视频
        else if (data['type'] === 'video') {
            element = document.createElement('video');
            element.addEventListener('loadedmetadata', function() {
            	// 安卓手机端的时长为0，使用定时器延迟获取仍然为0，且链接错误时不会触发error事件
            	data['duration'] = Math.round(element.duration * 100) / 100;
            	data['status'] = 'success';
            	element = null;
            	resolve(data);
            });
            element.addEventListener('error', function() {
            	data['duration'] = 0;
            	element = null;
            	resolve(data);
            });
            element.src = src;
            element.load();
        }
        // 其它文件
        else {
            resolve(data);
        }
    });
}
// 树结构遍历(异步函数)
async function treeEachSync(tree = {}, callback = null, key = 'su') {
    if (dataType(tree, 'object') && dataType(callback, 'function') && key) {
        let result = await callback(tree);
        tree = result === undefined ? tree : result;
    	if (tree && tree[key] && dataType(tree[key], 'array')) {
    		for (let i = 0, length = tree[key].length; i < length; i++) {
    			tree[key][i] = await treeEachSync(tree[key][i], callback, key);
    		}
    	}
    }
    return tree;
}

/**** 文件、数据获取 ****/
// 获取图文大小、音频时长、视频时长
export async function getFile(url = '') {
    const fileList = getLocalFile();
    const index = fileList.findIndex(file => file['url'] == url);
    if (index === -1) {
        const type = fileType(url);
        const result = await fileInfo(url, type);
        if (result.status === 'success') {
            setLocalFile(JSON.parse(JSON.stringify(result)));
        }
        return result;
    }
    return {
        status: 'success',
        ...fileList[index]
    };
}
// 获取用户、图文、对象、方程式数据
export async function getData(type = '', dataId = '', defaultData = Object.create(null), fromLocal = true) {
    /*
        type: user、tuwen、object、phamula
        dataId: user_id、tuwen_id、object_id、phamula_id
        defaultData: {}
        fromLocal: true(默认从本地查找，如果没有再从http获取)，false(从http获取)
    */
    let status = 'error';
    let data = null;
    if (thanZero(dataId)) {
        let result = null;
        if (type === 'user') {
            result = await getUser(dataId);
        }
        if (type === 'tuwen') {
            result = await getTuwen(dataId);
        }
        if (type === 'object') {
            result = await getObject(dataId);
        }
        if (type === 'phamula') {
            result = await getPhamula(dataId);
        }
        if (result && result.status === 'success' && result.data) {
            status = 'success';
            data = result.data;
            if (Object.keys(data).length && Object.keys(defaultData).length) {
                for (let [ key, value ] of Object.entries(defaultData)) {
                    defaultData[ key ] = data[ key ] || value;
                }
                return {
                    status,
                    data: defaultData
                };
            }
        }
    }
    return {
        status,
        data
    };
}

/**** 处理、绑定数据相关函数 ****/
// 判断是什么数据(用户、图文、对象、方程式、方程式树结构)
export function judgeData(data = {}, type = '') {
    if (data && type && dataType(data, 'object')) {
        // 判断是否是用户数据(user.public_profile接口没有user_id这个字段)
        if (type === 'user') {
            if (data['user_id'] || (['email', 'public_object_list'].every(key => key in data))) {
                return true;
            }
        }
        // 判断是否是图文数据
        if (type === 'tuwen') {
            if (data['tuwen_id'] || (['title', 'content'].every(key => key in data))) {
                return true;
            }
        }
        // 判断是否是对象数据
        if (type === 'object') {
            if (data['object_id'] || (['name', 'photo'].every(key => key in data))) {
                return true;
            }
        }
        // 判断是否是方程式数据
        if (type === 'phamula') {
            if (data['phamula_id'] || (['object_id', 'obj_relation_json'].every(key => key in data))) {
                return true;
            }
        }
        // 判断是否是方程式的树结构数据
        if (type === 'phamula_tree') {
            // 先判断是否是方程式
            if (data['phamula_id'] || (['object_id', 'obj_relation_json'].every(key => key in data))) {
                if (data['obj_relation_json'] && dataType(data['obj_relation_json'], 'object')) {
                    if (data.obj_relation_json['jsonStr'] && dataType(data.obj_relation_json['jsonStr'], 'object')) {
                        return true;
                    }
                }
            }
        }
    }
    return false;
}
// 获取or设置方程式缓存(已加载完毕数据的)
export function phamulaCache(data = null, type = '') {
    // 获取缓存中的方程式，此时data表示phamula_id
    if (data && type === 'get' && dataType(data, 'string,number')) {
        if (phamulaData[ data ] && phamulaData[ data ]._loaded) {
            let newPhamula = JSON.parse(JSON.stringify(phamulaData[ data ]));
            delete newPhamula['_loaded'];
            return newPhamula;
        }
    }
    // 设置缓存中的方程式，此时data表示phamula
    if (data && type === 'set' && judgeData(data, 'phamula_tree')) {
        let newPhamula = JSON.parse(JSON.stringify(data));
        newPhamula['_loaded'] = true;
        phamulaData[ data['phamula_id'] ] = newPhamula;
    }
}
// 将绑定的数据分解到缓存中
export function getBindDataToCache(data = {}) {
    if (data && dataType(data, 'object')) {
        // 获取用户数据到缓存(user.public_profile接口没有user_id这个字段)
        if (judgeData(data['_user_data'], 'user') && data['_user_data'].user_id) {
            if (userData[ data['_user_data'].user_id ]) {} else {
                userData[ data['_user_data'].user_id ] = data['_user_data'];
            }
        }
        // 获取图文数据到缓存
        if (judgeData(data['_tuwen_data'], 'tuwen') && data['_tuwen_data'].tuwen_id) {
            if (tuwenData[ data['_tuwen_data'].tuwen_id ]) {} else {
                tuwenData[ data['_tuwen_data'].tuwen_id ] = data['_tuwen_data'];
            }
        }
        // 获取对象数据到缓存
        if (judgeData(data['_object_data'], 'object') && data['_object_data'].object_id) {
            if (objectData[ data['_object_data'].object_id ]) {} else {
                objectData[ data['_object_data'].object_id ] = data['_object_data'];
            }
        }
        // 获取方程式数据到缓存
        if (judgeData(data['_phamula_data'], 'phamula') && data['_phamula_data'].phamula_id) {
            if (phamulaData[ data['_phamula_data'].phamula_id ]) {} else {
                phamulaData[ data['_phamula_data'].phamula_id ] = data['_phamula_data'];
            }
        }
        // 获取音频文件数据到缓存
        if (data['_audio'] && fileType(data['_audio'], 'audio')) {
            setLocalFile({
                url: data['_audio'],
                duration: data['_audio_duration'] || 0
            });
        }
        // 获取视频文件数据到缓存
        if (data['_video'] && fileType(data['_video'], 'video')) {
            setLocalFile({
                url: data['_video'],
                duration: data['_video_duration'] || 0
            });
        }
        // 未来可能有图片啥的...
    }
}
// 补全树结构数据中的rt、su、edd、tg、ed字段
export function completionTreeData(data = {}) {
    if (data && dataType(data, 'object')) {
        const parentKeyList = [ ['rt', ''], ['su', []], ['edd', ''] ];
        const childKeyList = [ ['tg', ''], ['ed', ''] ];
        parentKeyList.map(([key, defaultValue]) => {
            if (key in data) {
                parentKeyList.map(([_key, _defaultValue]) => data[_key] = data[_key] || _defaultValue);
            }
        });
        childKeyList.map(([key, defaultValue]) => {
            if (key in data) {
                childKeyList.map(([_key, _defaultValue]) => data[_key] = data[_key] || _defaultValue);
            }
        });
    }
    return data;
}
// 处理方程式树结构数据
export async function phamulaTreeHandler(phamula = {}, callback = null) {
    if (judgeData(phamula, 'phamula_tree')) {
        // 获取object_id集合
        const object_id_list = [];
        phamula.obj_relation_json['jsonStr'] = treeEach(phamula.obj_relation_json['jsonStr'], item => {
            if (item && dataType(item, 'object')) {
                // 父、子节点补齐 rt su edd tg ed
                item = completionTreeData(item);
                // 补上object_id
                item['object_id'] = '';
                // 获取object_id
                for (let key of ['edd', 'ed']) {
                    if ((key in item) && thanZero(item[key])) {
                        item['object_id'] = item[key];
                        if (object_id_list.indexOf(item[key]) === -1) {
                            object_id_list.push(item[key]);
                        }
                    }
                }
            }
            return item;
        });
        // 获取绑定的一堆数据
        for (let index = 0, length = object_id_list.length; index < length; index++) {
            let bindData = await getBindDataByObjectId(object_id_list[index]);
            // 数据绑定
            phamula.obj_relation_json['jsonStr'] = treeEach(phamula.obj_relation_json['jsonStr'], item => {
                if (item && dataType(item, 'object')) {
                    if (item['object_id'] == object_id_list[index]) {
                        item = Object.assign(item, bindData);
                    }
                }
                return item;
            });
            // 触发回调函数
            if (callback && dataType(callback, 'function')) {
                await callback('update', phamula, index, length);
            }
        }
    }
    return phamula;
}
// 补全绑定数据
export async function completionBindData(data = {}, key = '') {
    // key = edd 或 ed
    if (data && dataType(data, 'object')) {
        // 补全对象数据
        if (judgeData(data['_object_data'], 'object')) {} else {
            data['_object_data'] = data['_object_data'] || Object.create(null);
            if (data[key] && thanZero(data[key])) {
                // 获取对象数据
                let objectResult = await getData('object', data[key]);
                if (objectResult.status === 'success') {
                    data['_object_data'] = objectResult.data;
                }
            }
        }
        data['_name'] = data['_name'] || (data['_object_data'] && data['_object_data'].name) || ''; // 此处可改为newName
        data['_photo'] = data['_photo'] || (data['_object_data'] && data['_object_data'].photo) || '';
        // 补全音频
        data['_audio'] = data['_audio'] || '';
        data['_audio_duration'] = data['_audio_duration'] || 0;
        if (data['_audio'] && fileType(data['_audio'], 'audio')) {} else {
            // 获取视频数据
            if (data['_object_data'] && data['_object_data'].audio_url && fileType(data['_object_data'].audio_url, 'audio')) {
                let audioResult = await getFile(data['_object_data'].audio_url);
                if (audioResult.status === 'success') {
                    data['_audio'] = data['_object_data'].audio_url;
                    data['_audio_duration'] = audioResult.duration;
                }
            }
        }
        // 补全视频
        data['_video'] = data['_video'] || '';
        data['_video_duration'] = data['_video_duration'] || 0;
        if (data['_video'] && fileType(data['_video'], 'video')) {} else {
            // 获取视频数据
            if (data['_object_data'] && data['_object_data'].url && fileType(data['_object_data'].url, 'video')) {
                let videoResult = await getFile(data['_object_data'].url);
                if (videoResult.status === 'success') {
                    data['_video'] = data['_object_data'].url;
                    data['_video_duration'] = videoResult.duration;
                }
            }
        }
        // 补全图文数据
        if (judgeData(data['_tuwen_data'], 'tuwen')) {} else {
            data['_tuwen_data'] = data['_tuwen_data'] || Object.create(null);
            if (data['_object_data'] && data['_object_data'].tuwen_id && thanZero(data['_object_data'].tuwen_id)) {
                // 获取图文数据
                let tuwenResult = await getData('tuwen', data['_object_data'].tuwen_id);
                if (tuwenResult.status === 'success') {
                    data['_tuwen_data'] = tuwenResult.data;
                }
            }
        }
        // 补全方程式数据
        if (judgeData(data['_phamula_data'], 'phamula')) {} else {
            data['_phamula_data'] = data['_phamula_data'] || Object.create(null);
            if (data['_object_data'] && data['_object_data'].phamula_id && thanZero(data['_object_data'].phamula_id)) {
                // 获取方程式数据
                let phamulaResult = await getData('phamula', data['_object_data'].phamula_id);
                if (phamulaResult.status === 'success') {
                    data['_phamula_data'] = phamulaResult.data;
                }
            }
        }
    }
    return data;
}
// 根据object_id获取绑定的数据
export async function getBindDataByObjectId(object_id = '') {
    const bindData = Object.create(null);
    bindData['_tuwen_data'] = Object.create(null);
    bindData['_object_data'] = Object.create(null);
    bindData['_phamula_data'] = Object.create(null);
    bindData['_name'] = '';
    bindData['_photo'] = '';
    bindData['_audio'] = '';
    bindData['_video'] = '';
    bindData['_audio_duration'] = 0;
    bindData['_video_duration'] = 0;
    if (thanZero(object_id)) {
        // 获取对象数据
        let result = await getData('object', object_id);
        if (result.status === 'success') {
            bindData['_object_data'] = result.data;
            bindData['_name'] = result.data['name'] || ''; // 此处可改为newName
            bindData['_photo'] = result.data['photo'] || '';
            // 获取图文数据
            if (result.data['tuwen_id'] && thanZero(result.data['tuwen_id'])) {
                let tuwenResult = await getData('tuwen', result.data['tuwen_id']);
                if (tuwenResult.status === 'success') {
                    bindData['_tuwen_data'] = tuwenResult.data;
                }
            }
            // 获取方程式数据
            if (result.data['phamula_id'] && thanZero(result.data['phamula_id'])) {
                let phamulaResult = await getData('phamula', result.data['phamula_id']);
                if (phamulaResult.status === 'success') {
                    bindData['_phamula_data'] = phamulaResult.data;
                }
            }
            // 获取视频数据
            if (result.data['url'] && fileType(result.data['url'], 'video')) {
                let videoResult = await getFile(result.data['url']);
                if (videoResult.status === 'success') {
                    bindData['_video'] = result.data['url'];
                    bindData['_video_duration'] = videoResult.duration;
                }
            }
            // 获取音频数据
            if (result.data['audio_url'] && fileType(result.data['audio_url'], 'audio')) {
                let audioResult = await getFile(result.data['audio_url']);
                if (audioResult.status === 'success') {
                    bindData['_audio'] = result.data['audio_url'];
                    bindData['_audio_duration'] = audioResult.duration;
                }
            }
        }
    }
    return bindData;
}
// 根据方程式获取绑定的user、object数据
export async function getBindUserObjectData(phamula = {}) {
    if (phamula && dataType(phamula, 'object')) {
        phamula['_user_data'] = phamula['_user_data'] || Object.create(null);
        phamula['_object_data'] = phamula['_object_data'] || Object.create(null);
        phamula['_name'] = phamula['_name'] || (phamula['_object_data'] && phamula['_object_data'].name) || ''; // 此处可改为newName
        phamula['_photo'] = phamula['_photo'] || (phamula['_object_data'] && phamula['_object_data'].photo) || '';
        // 补全用户数据
        if (judgeData(phamula['_user_data'], 'user')) {} else {
            if (phamula['user_id'] && thanZero(phamula['user_id'])) {
                // 获取用户数据
                let userResult = await getData('user', phamula['user_id']);
                if (userResult.status === 'success') {
                    phamula['_user_data'] = userResult.data;
                }
            }
        }
        // 补全对象数据
        if (judgeData(phamula['_object_data'], 'object')) {} else {
            if (phamula['object_id'] && thanZero(phamula['object_id'])) {
                // 获取对象数据
                let objectResult = await getData('object', phamula['object_id']);
                if (objectResult.status === 'success') {
                    phamula['_object_data'] = objectResult.data;
                    phamula['_name'] = objectResult.data['name'] || ''; // 此处可改为newName
                    phamula['_photo'] = objectResult.data['photo'] || '';
                }
            }
        }
    }
    return phamula;
}

/**** 导出数据函数 ****/
// 导出当前数据
export function exportData(type = '') {
    // type: all、file、user、tuwen、object、phamula、objectBind
    if (type === 'all') {
        return {
            file: getLocalFile(),
            user: userData,
            tuwen: tuwenData,
            object: objectData,
            phamula: phamulaData
        };
    }
    if (type === 'file') {
        return getLocalFile();
    }
    if (type === 'user') {
        return Object.values(userData);
    }
    if (type === 'tuwen') {
        return Object.values(tuwenData);
    }
    if (type === 'object') {
        return Object.values(objectData);
    }
    if (type === 'phamula') {
        return Object.values(phamulaData);
    }
    if (type === 'objectBind') {
        return Object.keys(objectData).map(object_id => {
            let data = Object.create(null);
            data['object_id'] = object_id;
            data['_object_data'] = objectData[ object_id ] || Object.create(null);
            data['_tuwen_data'] = tuwenData[ data['_object_data'].tuwen_id || '' ] || Object.create(null);
            data['_phamula_data'] = phamulaData[ data['_object_data'].phamula_id || '' ] || Object.create(null);
            return data;
        });
    }
    return [];
}
// 根据方程式获取用户、图文、对象、方程式、图片、音频、视频数据(传type可导出)
export function exportDataByPhamula(phamula = {}, type = '') {
    if (phamula && dataType(phamula, 'object')) {
        // 获取方程式数据到缓存
        if (phamula['phamula_id']) {
            if (phamulaData[ phamula['phamula_id'] ]) {} else {
                phamulaData[ phamula['phamula_id'] ] = phamula;
            }
        }
        // 分解数据到缓存
        getBindDataToCache(phamula);
        // 分解树结构数据到缓存
        if (judgeData(phamula, 'phamula_tree')) {
            treeEach(phamula.obj_relation_json['jsonStr'], item => {
                if (item && dataType(item, 'object')) {
                    getBindDataToCache(item);
                }
            });
        }
    }
    if (type) {
        return exportData(type);
    }
}

/**** 获取方程式json文件数据 ****/
export async function getPhamulaJson(phamula_id = '', callback = null, initHandle = null) {
    // initHandle 在初次拉到数据之后对其处理，并返回处理后的结构，顺序在start、end之前(比如对jsonStr.su的数据重新排序或删除增加数据)
    if (phamula_id && thanZero(phamula_id)) {
        // 如果本地缓存存在且已经加载完毕数据就直接返回
        if (phamulaCache(phamula_id, 'get')) {
            let phamula = phamulaCache(phamula_id, 'get');
            // 触发初始化处理函数
            if (initHandle && dataType(initHandle, 'function')) {
                let tempPhamula = await initHandle(phamula);
                if (tempPhamula && dataType(callback, 'object')) {
                    phamula = tempPhamula;
                }
            }
            // 将所有数据添加至缓存中
            exportDataByPhamula(phamula);
            // 触发回调函数
            if (callback && dataType(callback, 'function')) {
                await callback('end', phamula);
            }
            return {
                status: 'success',
                data: phamula
            };
        }
        let result = await getData('phamula', phamula_id);
        // 可能存在result.status为success而result.data为null的情况
        if (result.status === 'success' && result.data && judgeData(result.data, 'phamula')) {
            // 补全用户、对象数据
            result.data = await getBindUserObjectData(result.data);
            // 触发初始化处理函数
            if (initHandle && dataType(initHandle, 'function')) {
                let tempPhamula = await initHandle(result.data);
                if (tempPhamula && dataType(callback, 'object')) {
                    result.data = tempPhamula;
                }
            }
            // 触发回调函数
            if (callback && dataType(callback, 'function')) {
                await callback('start', result.data);
            }
            // 处理json数据(回调函数参数分别为'update', phamula, index, length)
            result.data = await phamulaTreeHandler(result.data, callback);
            // 打下标记表示该方程式的数据已经全部加载完成
            phamulaCache(result.data, 'set');
            // 将所有数据添加至缓存中
            exportDataByPhamula(result.data);
            // 触发回调函数
            if (callback && dataType(callback, 'function')) {
                await callback('end', result.data);
            }
            return result;
        }
    }
    // 触发回调函数
    if (callback && dataType(callback, 'function')) {
        await callback('error', null);
    }
    return {
        status: 'error',
        data: null
    };
}

/**** 过滤方程式json文件数据 ****/
export async function filterPhamulaJson(phamula = {}, callback = null, initHandle = null) {
    // initHandle 在初次拉到数据之后对其处理，并返回处理后的结构，顺序在start、end之前(比如对jsonStr.su的数据重新排序或删除增加数据)
    const isObject = phamula && dataType(phamula, 'object');
    // 做到这里
    if (isObject && phamula['phamula_id']) {
        // 如果本地缓存存在且已经加载完毕数据就直接返回
        if (phamulaCache(phamula['phamula_id'], 'get')) {
            phamula = phamulaCache(phamula['phamula_id'], 'get');
            // 触发初始化处理函数
            if (initHandle && dataType(initHandle, 'function')) {
                let tempPhamula = await initHandle(phamula);
                if (tempPhamula && dataType(callback, 'object')) {
                    phamula = tempPhamula;
                }
            }
        } else {
            // 补全用户、对象数据
            phamula = await getBindUserObjectData(phamula);
            // 触发初始化处理函数
            if (initHandle && dataType(initHandle, 'function')) {
                let tempPhamula = await initHandle(phamula);
                if (tempPhamula && dataType(callback, 'object')) {
                    phamula = tempPhamula;
                }
            }
            // 触发回调函数
            if (callback && dataType(callback, 'function')) {
                await callback('start', phamula);
            }
            // 补齐json数据(没有update回调函数)
            if (judgeData(phamula, 'phamula_tree')) {
                phamula.obj_relation_json['jsonStr'] = await treeEachSync(phamula.obj_relation_json['jsonStr'], async item => {
                    if (dataType(item, 'object')) {
                        // 父、子节点补齐 rt su edd tg ed
                        item = completionTreeData(item);
                        // 补上object_id
                        item['object_id'] = '';
                        // 获取object_id
                        for (let key of ['edd', 'ed']) {
                            if ((key in item) && thanZero(item[key])) {
                                item['object_id'] = item[key];
                                // 父、子节点补齐数据
                                item = await completionBindData(item, key);
                            }
                        }
                    }
                    return item;
                });
            }
            // // 处理json数据(回调函数参数分别为'update', phamula, index, length)
            // phamula = await phamulaTreeHandler(phamula, callback);
            
            // 打下标记表示该方程式的数据已经全部加载完成
            phamulaCache(phamula, 'set');
        }
        // 将所有数据添加至缓存中
        exportDataByPhamula(phamula);
        // 触发回调函数
        if (callback && dataType(callback, 'function')) {
            await callback('end', phamula);
        }
        return phamula;
    }
    const errorData = {
        obj_relation_json: {
            jsonStr: Object.create(null),
            layer: 0,
            name: '',
            type: -1
        },
        upload_time: (isObject && phamula['upload_time']) || '',
        phamula_id: (isObject && phamula['phamula_id']) || '',
        object_id: (isObject && phamula['object_id']) || '',
        user_id: (isObject && phamula['user_id']) || '',
        _object_data: Object.create(null),
        _user_data: Object.create(null),
        _photo: '',
        _name: ''
    };
    // 触发回调函数
    if (callback && dataType(callback, 'function')) {
        await callback('error', errorData);
    }
    return errorData;
}

// import { judgeData, exportData, getPhamulaJson, filterPhamulaJson } from '@/utils/getPhamul.js'